import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

/** Copilot user settings (global instructions + memory toggle) and stored memories. */
export function createCopilotSettingsQueries(client: StoxlyClient) {
  return createQueryKeys('copilotSettings', {
    // ['copilotSettings', 'settings']
    settings: {
      queryKey: null,
      queryFn: ({ signal }) => client.copilotSettingsGetSettings({ signal }),
    },

    // ['copilotSettings', 'memories']
    memories: {
      queryKey: null,
      queryFn: ({ signal }) => client.copilotSettingsListMemories({ signal }),
    },
  });
}

export function createCopilotSettingsMutations(client: StoxlyClient) {
  return {
    updateSettings: {
      mutationFn: (body: Body<'copilotSettingsUpdateSettings'>) =>
        client.copilotSettingsUpdateSettings(body),
    },
    deleteMemory: {
      mutationFn: (id: string) => client.copilotSettingsDeleteMemory(undefined, { params: { id } }),
    },
    clearMemories: {
      mutationFn: () => client.copilotSettingsClearMemories(undefined),
    },
  };
}
